const pickupStoreWithEverythingInStock = (locations) => {
  if(!locations) { return null; }

  const storesAndAvailabilityPerDelOpt = {};
  for (const location of locations) {
    if(!location.orderTimestamps) { continue };

    for (const [delOpt, itemTimestamps] of Object.entries(location.orderTimestamps)) {
      storesAndAvailabilityPerDelOpt[delOpt] || (storesAndAvailabilityPerDelOpt[delOpt] = {})

      for (const [_itemId, itemTimestamp] of Object.entries(itemTimestamps)) {
        if (storesAndAvailabilityPerDelOpt[delOpt][itemTimestamp.store_number] == false) {
          // store already known to have unavaiability, we need not care about it anymore
          continue
        }

        storesAndAvailabilityPerDelOpt[delOpt][itemTimestamp.store_number] = itemTimestamp.service_available;
      }
    }
  }

  const locationsPerDeliveryOption = {};
  for (const [delOpt, storesAndAvailability] of Object.entries(storesAndAvailabilityPerDelOpt)) {
    locationsPerDeliveryOption[delOpt] || (locationsPerDeliveryOption[delOpt] = []);

    for (const [storeNumber, availability] of Object.entries(storesAndAvailability)) {
      if(availability) {
        locationsPerDeliveryOption[delOpt].push(storeNumber);
      }
    }
  }

  const locationsWithEverythingInStock = Object.values(locationsPerDeliveryOption)
    .reduce((locations, newLocations, idx) => idx == 0 ? newLocations : newLocations.filter(store => locations.includes(store)), [])
    .map(id => locations.find(l => l.id == id))
    .sort(_locationDistanceSorter);

  return locationsWithEverythingInStock[0] || null;
}

const _locationDistanceSorter = (a, b) => {
  const { distance: distanceA } = a || {},
        { distance: distanceB } = b || {},
        { miles: milesA } = distanceA || NaN,
        { miles: milesB } = distanceB || NaN;

  if(isNaN(milesA)) { return 1 };
  if(isNaN(milesB)) { return -1 };

  return milesA - milesB;
}

export { pickupStoreWithEverythingInStock, _locationDistanceSorter };